/* eslint-disable */
import type { TransactionReturnType } from "../types"
import type { Abi, Address } from "viem"
import type { Config } from "wagmi"

import { superVoterAbi } from "@/domains/abis"
import { simulatedTransaction } from "../simulated-transaction"

type MultiMaxLockProps = {
  account: Address
  chainId: number
  config: Config
  superVoterAddress: Address
  nftIds: Array<number>
}

export const maxLockMultiple = async ({
  account,
  chainId,
  config,
  superVoterAddress,
  nftIds,
}: MultiMaxLockProps): Promise<TransactionReturnType> => {
  try {
    const result = await simulatedTransaction({
      config,
      simulateArgs: {
        abi: superVoterAbi as Abi,
        account,
        address: superVoterAddress,
        args: [nftIds],
        chainId,
        functionName: "maxLockMultiple",
      },
    })
    return result
  } catch (error: any) {
    console.error("maxLockMultiple", error)
    return { success: false, error: error.message, code: error.code }
  }
}
